import { KellyTheme } from "../.internal/themes/KellyTheme";
export default KellyTheme;